import React from 'react';
import { Card, CardContent, Typography, Stack, Box } from '@mui/material';

class TableCard extends React.Component {
  render() {
    const { CardContentObject: CardContentComponent, headerActions } = this.props;

    return (
      <Card variant="outlined" sx={{ height: '100%', flexGrow: 1 }}>
        <CardContent>
          <Stack direction="row" sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography component="h4">{this.props.title}</Typography>
            {headerActions && (
              <Stack direction="row" spacing={1}>
                {headerActions.map((ActionComponent, index) => (
                  <Box key={index}>{ActionComponent}</Box>
                ))}
              </Stack>
            )}
          </Stack>
          <Stack direction="column" sx={{ justifyContent: 'space-between', flexGrow: 1 }}>
            <Stack sx={{ justifyContent: 'space-between' }}>
              <Stack
                direction="row"
                sx={{ justifyContent: 'space-between', alignItems: 'center' }}
              ></Stack>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {this.props.interval}
              </Typography>
            </Stack>
            {CardContentComponent && (
              <Box sx={{ mt: 2 }}>
                <div style={{ height: this.props.graphHeight }}>
                  <CardContentComponent {...this.props} />
                </div>
              </Box>
            )}
          </Stack>
        </CardContent>
      </Card>
    );
  }
}

TableCard.defaultProps = {
  title: 'Statistic Card',
  value: 'N/A',
  trend: 'stable',
  interval: 'This week',
  data: [],
  daysInWeek: [],
  chartColor: '#000000',
  CardContentObject: null, // Default to null
  headerActions: null, // Default to null
};

export default TableCard;
